import { gql } from '@apollo/client';

const GET_PRIVACY_POLICIES = gql`
  query GetPrivacyPolicies($lang: String!, $slug: String!) {
    sectionsBy(slug: $slug) {
      privacyPolicies {
        tituloPp
      }
    }
    privacyPolicies(where: {language: $lang}, first: 60) {
      nodes {
        content
        date
        title
        languageCode
        slug
      }
    }
  }
`;

export { GET_PRIVACY_POLICIES }
